import type { UseFormProps } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import i18next from 'i18next';
import * as Yup from 'yup';
import i18n from '@locales/i18n';

export type FormPhone = {
  phone: string;
};

export type FormName = {
  name: string;
};

export type FormEmail = {
  email: string;
};

const validationPhoneSchema = Yup.object().shape({
  phone: Yup.string().matches(/^[0-9]+$/, {
    message: i18next.t('Subscrib_Detail_License_11'),
    excludeEmptyString: true,
  }),
});

const validationNameSchema = Yup.object().shape({
  name: Yup.string().required(i18n.t('GNB_Profile_MyProfile_14')),
});

const validationEmailSchema = Yup.object().shape({
  email: Yup.string()
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, {
      message: i18n.t('Member_Manager_17'),
      excludeEmptyString: true,
    })
    .email(i18n.t('Member_Manager_17')),
});

export const phoneFormOptions: UseFormProps<FormPhone> = {
  resolver: yupResolver(validationPhoneSchema),
  mode: 'onChange',
  shouldFocusError: true,
};

export const nameFormOptions: UseFormProps<FormName> = {
  resolver: yupResolver(validationNameSchema),
  mode: 'onChange',
  shouldFocusError: true,
};

export const emailFormOptions: UseFormProps<FormEmail> = {
  resolver: yupResolver(validationEmailSchema),
  mode: 'onChange',
  shouldFocusError: true,
};
